import * as R from "ramda";

export function validateEmptyValue(data) {
  if (R.and(data.mandatory, R.or(!data.value, R.isEmpty(data.value)))) {
    return typeof data.mandatory === "string"
      ? data.mandatory
      : "Field belum diisi";
  }

  return null;
}

export function validateMaxLength(data) {
  if (data.max && data.value && R.gt(data.value.length, data.max.value)) {
    return data.max.message
      ? data.max.message
      : "Field length cannot be greater than " + data.max.value;
  }

  return null;
}

export function validateMinLength(data) {
  if (data.min && data.value && R.lt(data.value.length, data.min.value)) {
    return data.min.message
      ? data.min.message
      : "Field length cannot be lower than " + data.min.value;
  }

  return null;
}
